"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reasoningPart = reasoningPart;
exports.normalizeReasoningTextPart = normalizeReasoningTextPart;
const json_1 = require("../../utils/json");
/** String payloads become visible reasoning text; everything else is data. */
function reasoningPart(payload, signature) {
    return {
        type: "reasoning",
        content: typeof payload === "string"
            ? (0, json_1.compact)({ kind: "text", text: payload, signature })
            : { kind: "data", value: (0, json_1.toJsonValue)(payload) },
    };
}
/** Universal reasoning-text block: `reasoning`/`reasoning_text`/`summary_text`
 * all carry their payload under one of text/content/thinking/summary. */
function normalizeReasoningTextPart(value) {
    const reasoning = value.text ?? value.content ?? value.thinking ?? value.summary;
    return reasoningPart(reasoning);
}
